import React from 'react';
import {Button, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';

export default (props) => {
  const {icons, currentIcon, onChange} = props;
  const [showModal, setShowModal] = React.useState(false);
  const [selected, setSelected] = React.useState(currentIcon || null);

  // Rester aligné si le parent change currentIcon (ex. ouverture d'une autre option en édition).
  React.useEffect(() => { setSelected(currentIcon || null); }, [currentIcon]);

  const handleClick = (iconId) => {
    setSelected(iconId);
    onChange(iconId);
    setShowModal(false);
  };

  const activeSvg = selected && icons[selected];

  return (
    <div className="cc-iconpicker">
      <button type="button" className="cc-iconpicker-trigger" onClick={() => setShowModal(true)}>
        {activeSvg
          ? <span className="cc-iconpicker-trigger-icon" dangerouslySetInnerHTML={{__html: activeSvg}}/>
          : <span className="cc-iconpicker-trigger-icon is-empty"/>}
        <span className="cc-iconpicker-trigger-label">
          <FormattedMessage id={activeSvg ? 'CHANGE_ICON' : 'CHOOSE_ICON'}/>
        </span>
      </button>

      <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6"><FormattedMessage id="CHOOSE_ICON"/></Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)}/>
        </Modal.Header>
        <Modal.Body>
          <div className="cc-iconpicker-grid">
            {Object.entries(icons).map(([key, svg]) => (
              <button
                key={key}
                type="button"
                title={key}
                aria-label={key}
                className={`cc-iconpicker-tile ${selected === key ? 'is-selected' : ''}`}
                onClick={() => handleClick(key)}
                dangerouslySetInnerHTML={{__html: svg}}
              />
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
